import { APP } from 'src/Configs/App'
import { rtkApi } from 'src/Services/rtkApi'
import { CampaignStatusEnum, CampaignTypeEnum } from 'src/Types/campaigns'

type Response = {
  status: CampaignStatusEnum
  userId: number
  trackId: number
  confirmationEmailSentAt: string
  type: CampaignTypeEnum
  isFeed: boolean
  startDate: null | string
  endDate: null | string
  streamsCount: number
  listenersCount: number
  paymentId: null | number
  amount: null | number
  currentAmount: null | number
  metadata: null
  isNewRewardSystem: null | boolean
  id: number
  artistFollowers: number
  artistMonthlyListeners: number
  artistFollowersResult: number
  playlistsFollowersResult: number
  playlistsAdds: number
  createdAt: string
  updatedAt: string
  areGenresUpdated: boolean
}

const relaunchCampaignApi = rtkApi.injectEndpoints({
  endpoints: (builder) => ({
    relaunchCampaign: builder.mutation<Response, number>({
      query: (campaignId) => ({
        url: `${APP.TIKTOK_SERVER}/artist/spotify-campaigns/relaunch`,
        method: 'POST',
        body: {
          campaignId,
        },
      }),
    }),
  }),
  overrideExisting: false,
})

export const { useRelaunchCampaignMutation } = relaunchCampaignApi
